<template>
  <!-- test data :: <pre>{{ transactions }}</pre>  -->
  <AdminBackground>
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PENGURUSAN MAKLUMAT.png"
          alt="PENGURUSAN MAKLUMAT"
          class="pbt-image"
        >
        <!-- Center the line under the image -->
        <div class="line-under-image" />
      </div>
      <div class="pbtpay-status">
        <h2>ePBT</h2>
        
        <Update />
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <PengurusanMaklumat />
</template>

<script setup>
import PengurusanMaklumat from '@/components/menu-items/section-menu/pengurusan-maklumat-menu.vue'


//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

/* Gap between line and the map */
.map-gap {
  margin-block: 10px; /* Increase this for more gap */
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
}


.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}
</style>
